(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2737],{

/***/ 2737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Content055": function() { return /* binding */ Content055; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87900);
/* harmony import */ var _Content055_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43246);
/* harmony import */ var _Content055_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Content055_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var Content055 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var template = (ref1 = payload === null || payload === void 0 ? void 0 : payload.template) !== null && ref1 !== void 0 ? ref1 : "light";
    var ref2;
    var points = (ref2 = payload === null || payload === void 0 ? void 0 : payload.faq) !== null && ref2 !== void 0 ? ref2 : [];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Content055_module_scss__WEBPACK_IMPORTED_MODULE_3___default().wrapper), (_Content055_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[template]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
            className: (_Content055_module_scss__WEBPACK_IMPORTED_MODULE_3___default().inner),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Content055_module_scss__WEBPACK_IMPORTED_MODULE_3___default().blocks),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Heading3 */ .aC, {
                        as: "h3",
                        className: (_Content055_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_Content055_module_scss__WEBPACK_IMPORTED_MODULE_3___default().content),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .AccordionList */ .ES, {
                            items: points,
                            className: (_Content055_module_scss__WEBPACK_IMPORTED_MODULE_3___default().list),
                            appearance: "bold",
                            togglePlus: true
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Content055);


/***/ }),

/***/ 43246:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content055_wrapper__KKIF9","light":"Content055_light__qcTRZ","grey":"Content055_grey__By2eD","blocks":"Content055_blocks__Rtx5B","content":"Content055_content__6GbuJ","title":"Content055_title__d__mZ","list":"Content055_list__Iz_9e"};

/***/ })

}]);